import { IOverflowSetItemProps } from "@fluentui/react";

export enum ECardIcon {
    lock,
    check,
    error,
    link,
    copy,
    add
}

export enum ECalloutTypes {
    comment,
    notification
}
export interface ICardProperties {
    title?: string;
    description?: string;
    children?: any;
    onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
    onRenderBack?: () => JSX.Element;
    onRenderFront?: () => JSX.Element;
    onCallout?: () => JSX.Element;
    autoCallout?: boolean;
    callout?: ECalloutTypes,
    selected?: boolean;
    overflowItems?: IOverflowSetItemProps[];
    disabled?: boolean;
    icons?: ECardIcon;
    onHover?: () => JSX.Element;
    comparison?: boolean;
    change?: boolean;
    header?: string;
    changeText?: string;
    deactivated?: boolean;
    labelText?: string;
    subText?: string;
    onRenderFooter?: () => JSX.Element;
}